
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerWest as ObiBeaconTowerWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-west.js';
 
 
 

 
 export const ObiBeaconTowerWest = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-west',
   elementClass: ObiBeaconTowerWestElement,
   events: {
     
   }
  });
 
 